<p>
  service-package-detail works!
</p>
